/*
==========================================================
CLIENT CONSTANTS
==========================================================
*/

export const emptyClient = {

  /* ======================================================
     GENERAL
  ====================================================== */

  name: "",

  email: "",

  phone: "",

  type: "person",

  status: "active",

  /* ======================================================
     COMPANY
  ====================================================== */

  company: "",

  identification: "",

  /* ======================================================
     ADDRESS
  ====================================================== */

  country: "",

  province: "",

  city: "",

  address: "",

  /* ======================================================
     CONTACT
  ====================================================== */

  whatsapp: "",

  preferredLanguage: "es",

  /* ======================================================
     INTERNAL
  ====================================================== */

  notes: ""

};

export const selectPortal = {
   menuPortalTarget: document.body,
   menuPosition: "fixed",
   styles: {
   menuPortal: base => ({ ...base, zIndex: 9999 })
   }
};